import {
    Form,
    Row,
    Input,
    Space,
    Button,
    message,
    Modal,
    Select,
  } from "antd";
  import { useEffect, useState } from "react";
  import { Link, useNavigate } from "react-router-dom";
  import { ExclamationCircleOutlined } from "@ant-design/icons";
  import CustomUpload from "../customUpload";
import axiosInstance from "../../utils/axios";
import CustomSunEditor from "../customSunEditor";
  
  export default function MakeMoneyForm({
    id = "",
    initialValues = {},
    onSubmit = () => {},
  }) {
    const navigate = useNavigate();
    const [editorValue, setEditorValue] = useState('');
    const [form] = Form.useForm();
  
    const deleteMakeMoney = async () => {
      await axiosInstance.delete(`/make-money/delete/${id}`)
        .then((res) => message.success(String(res?.data?.message)))
    };
  
    useEffect(() => {
      if (Object.keys(initialValues)?.length > 0) {
        form.resetFields();
      }
    }, [form, initialValues]);
  
    const removeMakeMoney = async () => {
      try {
        await deleteMakeMoney();
        return navigate("/admin/quan-ly-make-money");
      } catch (err) {
        console.log(err.message);
      }
    };
  
    const confirmDeleteBusiness = () => {
      Modal.confirm({
        icon: <ExclamationCircleOutlined />,
        content: "Bạn có chắc chắn xoá nhiệm vụ này?",
        okText: "Xác nhận",
        cancelText: "Huỷ",
        onOk: () => removeMakeMoney(),
      });
    };
    return (
      <div className={"p-[40px] bg-white rounded-[10px]"}>
        <div className={"!text-[#2d2e32] pb-[10px]"}>
          <Link
            to={"/admin/quan-ly-make-money"}
            className={
              "text-[18px] sm:text-[24px] md:text-[26px] xl:text-[26px] font-[500] cursor-pointer "
            }
          >
            {"Thông tin Nhiệm vụ"}
          </Link>
        </div>
  
        <Form
          layout={"vertical"}
          colon={false}
          form={form}
          initialValues={initialValues}
          onFinishFailed={(e) => console.log(e)}
          onFinish={onSubmit}
        >
            <Form.Item
                label={"Tiêu đề"}
                name="make_money_tittle"
                rules={[{ required: true, message: "Vui lòng nhập tiêu đề!" }]}
            >
                <Input size="large" placeholder={"Nhập"} />
            </Form.Item>

            <Form.Item
                label={"Tiền thưởng"}
                name="money"
                rules={[{ required: true, message: "Vui lòng nhập tiền thưởng!" }]}
            >
                <Input type="number" size="large" placeholder={"Nhập"} />
            </Form.Item>
    
            <Form.Item
                name="make_money_image"
                label={"Link ảnh"}
                rules={[{ required: true, message: "Vui lòng chọn file!" }]}
            >
                <CustomUpload type="image" accept=".png, .jpg, .jpeg, .jfif" />
            </Form.Item>

            <Form.Item
                label={"Nội dung"}
                name="make_money_content"
                rules={[{ required: true, message: "Vui lòng nhập nội dung!" }]}
            >
                <CustomSunEditor value={editorValue} onChange={(e)=> setEditorValue(e)} />
            </Form.Item>
  
          <Row gutter={40} className={"my-[40px] pl-[20px]"}>
              <Space align="center">
              <Button type={"primary"} htmlType={"submit"}>
                  {id && id !== "tao-moi" ? "Cập nhập" : "Tạo"}
              </Button>
              {id && id !== "tao-moi" && (
                  <Button type={"primary"} danger onClick={confirmDeleteBusiness}>
                      Xoá
                  </Button>
              )}
              </Space>
          </Row>
        </Form>
      </div>
    );
  }
  